import React from "react";
import { Box } from "@mui/material";
import { endOfYear, getDayOfYear, startOfYear } from "date-fns";
import { useOcCalendar } from "oc/hooks";

// TODO: Add useTheme

interface MyLeaveCalendarWeeklyTimelineDateHeaderProps {
  date: Date;
  label: string;
  isOffRange?: boolean;
}

export const MyLeaveCalendarWeeklyTimelineDateHeader = ({
  date,
  label,
  isOffRange,
}: MyLeaveCalendarWeeklyTimelineDateHeaderProps) => {
  let startDate = startOfYear(date);
  let endDate = endOfYear(date);

  const { data: Calendar } = useOcCalendar({ startDate, endDate });
  let day = getDayOfYear(date);
  let dayState = Calendar.charAt(day - 1);

  let color = "#212121";
  if (isOffRange) {
    color = "#ffffff";
  }
  if (dayState === "F") {
    color = "#cc0033";
  }

  return (
    <Box style={{ textAlign: "center" }}>
      <span
        style={{
          fontSize: 16,
          fontWeight: "normal",
          color: color,
        }}
      >
        {label}
      </span>
    </Box>
  );
};

export default MyLeaveCalendarWeeklyTimelineDateHeader;
